<template>
  <div>
    <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
      <h4 class="panel-title">{{ $t('reports.unpaidReceivedInvoicesTitle') }}</h4>
      <v-btn v-if="rows.length" @click="printReport()" color="blue-grey" dark small class="no-print">
        <v-icon left small>print</v-icon> {{ $t('printLogs.printButton') }}
      </v-btn>
      <img src="../../../assets/images/black_shipzone.png" class="print-only" style="height:40px;" alt="Lasshopping" />
    </div>
    <div class="panel-body" style="display: block">
      <table v-if="rows.length" class="table table-bordered">
        <thead style="background-color:#4A8AF4; color:#fff;">
          <tr>
            <th>#</th>
            <th>{{ $t('columns.invoiceNo') }}</th>
            <th>{{ $t('columns.customer') }}</th>
            <th>{{ $t('reports.numberOfOrders') }}</th>
            <th>{{ $t('common.date') }}</th>
            <th>{{ $t('columns.amount') }} ($)</th>
            <th>{{ $t('reports.paid') }} ($)</th>
            <th>{{ $t('columns.remaining') }} ($)</th>
            <th>{{ $t('columns.status') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in rows" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.invoice_number }}</td>
            <td>{{ item.customer_name }}</td>
            <td>{{ item.order_count }}</td>
            <td>{{ item.invoice_date }}</td>
            <td>${{ fmt(item.total_amount) }}</td>
            <td style="color:green;">${{ fmt(item.paid_amount) }}</td>
            <td style="color:red;">${{ fmt(item.remaining) }}</td>
            <td>
              <span :style="{ background: item.payment_status === 'Not Paid' ? '#c62828' : '#f57c00', color: '#fff', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', whiteSpace: 'nowrap' }">
                {{ item.payment_status }}
              </span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr style="background-color:#e9f5b7; font-weight:bold;">
            <td colspan="5">{{ $t('columns.total') }}</td>
            <td>${{ sumTotal }}</td>
            <td style="color:green;">${{ sumPaid }}</td>
            <td style="color:red;">${{ sumRemaining }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
      <div v-if="loading" class="text-xs-center pa-3"><v-progress-circular indeterminate color="primary"></v-progress-circular></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
  data() {
    return {
      loading: false,
      rows: [],
      headers: [
        { text: 'Invoice #', value: 'invoice_number' },
        { text: 'Customer', value: 'customer_name' },
        { text: 'Orders', value: 'order_count' },
        { text: 'Date', value: 'invoice_date' },
        { text: 'Amount ($)', value: 'total_amount' },
        { text: 'Paid ($)', value: 'paid_amount' },
        { text: 'Remaining ($)', value: 'remaining' },
        { text: 'Status', value: 'payment_status' }
      ]
    }
  },
  computed: {
    sumTotal() {
      return this.rows.reduce((s, r) => s + parseFloat(r.total_amount || 0), 0).toFixed(2)
    },
    sumPaid() {
      return this.rows.reduce((s, r) => s + parseFloat(r.paid_amount || 0), 0).toFixed(2)
    },
    sumRemaining() {
      return this.rows.reduce((s, r) => s + parseFloat(r.remaining || 0), 0).toFixed(2)
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    fmt(v) {
      return parseFloat(v || 0).toFixed(2)
    },
    printReport() { window.print() },
    loadData() {
      this.loading = true
      const token = localStorage.getItem('access_token')
      axios
        .post('api/report/unpaid-invoices', { type: 'received' }, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(res => { this.rows = res.data.rows })
        .catch(() => swal(this.$t('common.error'), this.$t('reports.failedToLoadInvoices'), 'error'))
        .finally(() => { this.loading = false })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/unpaidReceivedInvoices.vue